import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { getData } from '../../Helpers/requests';

// import { useNavigate } from 'react-router-dom';

import { FormCategory } from '../shared/FormElements';

// import { GetAuth } from '../../Auth/AuthProvider';

import { optionsList } from '../../Helpers/helpers';

// import { Debounced } from 'react-debounce-input';

import DatePicker from '../CommonComponents/DatePicker_v2';
import {
  Input,
  Button,
  Card,
  Grid,
  Box,
  Stack,
  NativeSelect,
  Typography,
  TextField,
} from '@mui/material';
// import Customer from '../Customer/Customer';

export default function SerialAddHistory(props) {
  const [usersData, setUsersData] = useState([]); //Constant - Regions List

  const serialId = props.serialId;
  const [description, setDescription] = useState('');
  const [technicianId, setTechnicianId] = useState('1');
  const [ticketDate, setTicketDate] = useState(new Date());
  const [ticketMeta, setTicketMeta] = useState('');

  const closeModel = props.closeModel;

  useEffect(() => {
    getData(`users`, {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'name',
              search: '',
              strict: false,
            },
          ],
        },
      },
    }).then((data) => {
      setUsersData(data.data.value);
    });
  }, []);

  function CreateEntry(entry, updateFunc) {
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');

    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {
      serialhistory: entry,
    };

    const request = new Request(`${APIROOT}/api/serialnumberhistory`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });

    fetch(request)
      .then((data) => {
        if (data.status === 200) {
          return data.text();
        } else {
          throw new Error(`Invalid Response`);
        }
      })
      .then((data) => {
        var parsed = JSON.parse(data);
        if (parsed.success === true) {
          // console.log('entry created!');
          updateFunc((i) => (i = 1));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleAutoComplete = (event, newValue) => {
    setTicketDate(newValue);
  };
  const handleChange = (event) => {
    let checkEvent = event.target.id;
    switch (checkEvent) {
      case 'ticketNumber':
        setTicketMeta(event.target.value);
        break;
      case 'description':
        setDescription(event.target.value);
        break;
      case 'technician':
        setTechnicianId(event.target.value);
        break;
      case 'date':
        setTicketDate(event.target.value);
        break;
      default:
    }
  };

  // const navigateBack = useNavigate();

  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          // borderRadius: 15,
          padding: '5px 10px ',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5' sx={{ height: 40 }}>
            Cabinet Detail
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Card sx={{ boxShadow: 'none', border: 'none', background: 'none' }}>
            <Box sx={{ width: '100%' }}>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={0.5}
              >
                <Grid item xs={12} md={2}>
                  <FormCategory title='Ticket Number:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    sx={{ width: '100%', background: '#ffffff' }}
                    name='ticketNumber'
                    key='ticketNumber'
                    id='ticketNumber'
                    onChange={handleChange}
                    value={ticketMeta}
                    defaultValue={ticketMeta}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Description:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    sx={{ width: '100%', background: '#ffffff' }}
                    name='description'
                    key='description'
                    id='description'
                    onChange={handleChange}
                    value={description}
                    defaultValue={description}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Technician:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <NativeSelect
                    sx={{ width: '100%', background: '#ffffff' }}
                    name='technician'
                    key='technician'
                    variant='technician'
                    defaultValue={technicianId}
                    id='technician'
                    // value={technicianId}
                    onChange={handleChange}
                  >
                    {optionsList(
                      usersData === undefined
                        ? [{ id: '1', name: 'loading' }]
                        : usersData
                    )}
                  </NativeSelect>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormCategory title='Date:' />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DatePicker
                    // dateLabel='End Date'
                    getDate={(data) => {
                      console.log(data);
                      handleAutoComplete('rangeStart', data);
                    }}
                    // value={filterModalEventFields.startDate}
                    // value={dayjs(filterModalEventFields.startDate)}
                    defaultDate={ticketDate}
                  />
                  {/* <TextField
                    id='date'
                    key='date'
                    name='date'
                    type='date'
                    onChange={handleChange}
                    defaultValue={new Date()}
                    // default={installDate}
                    // value={installDate}
                    sx={{ width: '100%', background: '#ffffff' }}
                    variant='standard'
                    InputLabelProps={{
                      shrink: true,
                    }}
                  /> */}
                </Grid>

                <Grid item xs={12} md={12}>
                  <Stack
                    spacing={2}
                    direction='row'
                    sx={{ float: 'right', margin: '15px' }}
                  >
                    <Button
                      variant='contained'
                      onClick={() => {
                        // navigateBack(`/Serial`, { replace: true });
                        closeModel();
                        CreateEntry(
                          {
                            serial_number_id: serialId,
                            description: description,
                            technician_id: technicianId,
                            ticket_date: ticketDate,
                            ticket_meta: ticketMeta,
                          },
                          props.forceUpdate
                        );
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant='outlined'
                      onClick={() => {
                        closeModel();
                      }}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
